
import {defineComponent} from 'vue';
import L, {control} from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {WGStoLV95, LV95toWGS} from "swiss-projection"
import {mapConfig} from "@/config/app-settings";

export default defineComponent({
  name: "LocationPickerMap",
  data() {
    return {
      map: {} as L.Map,
      mapReady: false,
      marker: {} as L.Marker,
    }
  },
  props: {
    x: {type: Number, default: 0},
    y: {type: Number, default: 0},
  },
  methods: {
    setupMap() {

      this.map = mapConfig('location-picker-map')

      this.map.on('click', (e: L.LeafletMouseEvent) => {
        const latlng = this.map.mouseEventToLatLng(e.originalEvent)
        const coordsWGStoCH = WGStoLV95([latlng.lng, latlng.lat])
        this.$emit('select', [coordsWGStoCH[0], coordsWGStoCH[1]])
      })
      this.mapReady = true
      this.setupMarker()
    },
    setupMarker() {
      if (!this.mapReady) return
      if (this.marker) {
        this.map.removeLayer(this.marker as L.Marker)
      }
      this.marker = new (L.marker as any)([this.latLng[1], this.latLng[0]], {
        icon: this.defaultIcon,
        draggable: true
      })
      this.map.addLayer(this.marker as L.Marker)
      this.marker.on('dragend', () => {
        const latlng = this.marker.getLatLng()
        const coords = WGStoLV95([latlng.lng, latlng.lat])
        this.$emit('select', [coords[0], coords[1]]) // Emit swiss coords
      })
    }
  },
  computed: {
    latLng(): [number, number] {
      return LV95toWGS([this.x, this.y]) as [number, number]
    },
    defaultIcon(): L.Icon {
      return new (L.icon as any)({
        iconUrl: require('../../../node_modules/leaflet/dist/images/marker-icon.png'),
        iconSize: [30, 45],
        iconAnchor: [15, 38]
      })
    }
  },
  mounted() {
    // Need to wait
    window.setTimeout(() => {
      this.setupMap()
    }, 100)
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove()
    }
  },
  watch: {
    y() {
      this.setupMarker()
    },
    x() {
      this.setupMarker()
    }

  }
})
